// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import styles from './styles';

class Shop extends React.Component {
  state = {};

  render() {
    const { classes, shop } = this.props;
    return (
      <div className={classes.mainContainer}>
        <span className={classes.regularSmallText}>
          <h6 className={classes.textBold}>Parcel shop ID #</h6>
          <h6>{shop.ExternalId}</h6>
        </span>
        <span className={classes.regularSmallText}>
          <h6 className={classes.textBold}>Location:</h6>
          <h6>{`${shop.Address.City} city, ${shop.Address.Street}`}</h6>
        </span>
        <span className={classes.regularSmallText}>
          <h6 className={classes.textBold}>Telephone:</h6>
          <h6>{shop.Address.Telephone}</h6>
        </span>
        <div>
          <h6 className={classes.boldSmallText}>Working hours:</h6>
          {shop.BusinessHours.map(el => (
            <div key={uuidv4()} className={classes.regularSmallText}>
              <span className={classes.marginRight}>{el.DayOfWeek}</span>
              <div className={classes.timeContainer}>
                <h6>{el.OpenFrom}</h6>
                <span> - </span>
                <h6>{el.OpenTill}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

Shop.propTypes = {
  classes: PropTypes.object,
  shop: PropTypes.object,
};

Shop.defaultProps = {
  classes: {},
  shop: {},
};

export default withStyles(styles)(Shop);
